import React from 'react';
import {FormattedMessage} from 'react-intl';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import {onEnter, onExit} from "../../../config/customModalFunctions";

function ConfirmationModal(props) {
  const toggle = () => {
    props.closeModal();
  }

  const {
    className,
    messageId,
  } = props;

  if (!props.showModal) {
    return null;
  }
  return (
    <Modal
      isOpen={props.showModal}
      toggle={toggle}
      className={className}
      onEnter={onEnter}
      onExit={onExit}
      returnFocusAfterClose={false}
      centered
    >
      <ModalHeader toggle={toggle}>
        <FormattedMessage id="components.layout.confirmation.modal_title"/>
      </ModalHeader>
      <ModalBody>
        <FormattedMessage
          id={messageId ? messageId : "components.layout.confirmation.body"}/>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => {
          props.confirmationYes();
        }}
        >
          <FormattedMessage id="button.yes"/>
        </Button>
        <Button color="secondary" onClick={toggle}>
          <FormattedMessage id="button.no"/>
        </Button>
      </ModalFooter>
    </Modal>
  );
}

ConfirmationModal.defaultProps = {
  confirmationYes: null,
  show: false
};

export {ConfirmationModal};
